require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./powered-by-code-fellows.json") })
        }
      }, "path---powered-by-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---powered-by-code-fellows!./.cache/json/powered-by-code-fellows.json
// module id = 1235
// module chunks = 231608221292675